<style lang="stylus">
    .pcview-WarnTips-tips
        display flex
        justify-content center
        align-items center
        width calc(100% - 24px)
        height 40px
        background linear-gradient(98deg, #FFFAF3 0%, #FFF7EC 100%);
        border-radius 6px
        flex-shrink 0
        margin-bottom 24px

        p
            display flex
            align-items center
            font-size 14px
            line-height 16px
            max-width 100%
            padding 0 10px
            overflow hidden
            text-overflow ellipsis

        span
            font-size 12px
            line-height 16px
            user-select none

        .WarnTips-title
            color #632400
            margin-right 16px

        .WarnTips-btn
            display flex
            justify-content center
            align-items center
            height 24px
            padding 0 8px
            color #632400
            background linear-gradient(98deg, #FFEDD1 0%, #FFCF88 100%)
            cursor pointer
            border-radius 4px
            flex-shrink 0

    .dark-theme__pcviewWarnTips-tips
        background linear-gradient(98deg, #33312F 0%, #33312F 100%)

        .WarnTips-title
            color rgba(255, 211, 146, 1)
            &.white-title
                color #fff
</style>

<template>
    <div class="pcview-WarnTips-tips" :class="{ 'dark-theme__pcviewWarnTips-tips': isPCDarkMode == 2 }" v-if="show">
        <p :title="titleText">
            <slot name="icon"></slot>
            <span class="WarnTips-title" :class="{ 'white-title': vip }">{{ normalText }}</span>
            <slot name="invite"></slot>
            <span class="WarnTips-btn" v-if="showVipText" @click="toBuy">{{ vipText }}</span>
        </p>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class WarnTips extends Vue {
        @Prop()
        show;
        @Prop({ default: true })
        showVipText;
        @Prop()
        normalText;
        @Prop()
        vipText;
        @Prop()
        triggerStr;

        get titleText() {
            const normalText = this.normalText ? this.normalText : "";
            const vipText = this.showVipText ? this.vipText : "";
            return normalText.replace(/\<.[^\>]*\>/g, "");
        }
        toBuy() {
            this.$emit("clickBuy");
            this.$openBuyPage(this.triggerStr);
        }
        created() {}
        mounted() {}
    }
</script>
